module.exports = __webpack_public_path__ + "static/media/logo-instagram-hover.a56dba5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-instagram-hover.svg
// module id = 684
// module chunks = 0